import React from "react";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export const RelationshipsPanel = ({ edges, onNewEdge, onEditEdge, onDeleteEdge }) => (
  <div>
    <div className="flex items-center justify-between mb-4">
      <div>
        <h2 className="font-serif text-2xl text-foreground">Relationships</h2>
        <p className="text-xs text-muted-foreground">{edges.length} edges</p>
      </div>
      <Button onClick={onNewEdge} data-testid="add-edge-btn" className="bg-primary hover:bg-primary/90">
        <Plus className="w-4 h-4 mr-2" /> New relationship
      </Button>
    </div>
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <table className="w-full text-sm" data-testid="edge-table">
        <tbody>
          {edges.map((e) => (
            <tr key={e.id} className="border-b border-border last:border-0 hover:bg-secondary/30 transition-colors" data-testid={`edge-row-${e.id}`}>
              <td className="px-5 py-3">
                <span className="font-medium text-foreground">{e.source_label}</span>
                <Badge variant="outline" className="mx-2 border-accent/40 text-accent">{e.label}</Badge>
                <span className="font-medium text-foreground">{e.target_label}</span>
                {e.props?.stance && <span className="ml-2 text-xs text-muted-foreground">[{e.props.stance}]</span>}
              </td>
              <td className="px-5 py-3 w-24">
                <div className="flex justify-end gap-1">
                  <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => onEditEdge(e)} data-testid={`edit-edge-${e.id}`}>
                    <Pencil className="w-4 h-4" />
                  </Button>
                  <Button variant="ghost" size="icon" className="h-8 w-8 text-destructive" onClick={() => onDeleteEdge(e.id)} data-testid={`delete-edge-${e.id}`}>
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </div>
              </td>
            </tr>
          ))}
          {edges.length === 0 && <tr><td className="px-5 py-8 text-center text-muted-foreground">No relationships yet.</td></tr>}
        </tbody>
      </table>
    </div>
  </div>
);
